import styled from 'styled-components';
import { SHELL_HEADER_HEIGHT } from 'spark-views/common/header/navigationBarConfig';

const ApplicationBody = styled.div`
    overflow: auto;
    display: block;
    position: relative;
    min-height: calc(100vh - ${SHELL_HEADER_HEIGHT}px);
`;

export default ApplicationBody;
